export default __webpack_public_path__ + "static/media/flow1.21e530b8.svg";